export default __webpack_public_path__ + "static/media/044-map.e77f2790.png";